import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const path = to.path;
    // Replace multiple slashes with a single slash
    let normalized = path.replace(/\/{2,}/g, '/');

    // Remove trailing slash (except for root)
    if (normalized.length > 1 && normalized.endsWith('/')) {
        normalized = normalized.replace(/\/+$/, '');
    }

    if (normalized !== path) {
        return navigateTo({ path: normalized, query: to.query, hash: to.hash }, { redirectCode: 301 });
    }
});
